// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"1a5a64f5","580":"0d3f5581"}[chunkId] + ".chunk.css";
};